/**
 * Created by liux on 2017/9/24.
 */
import {store as loginModule , plugins as loginplugins} from 'bjxy-login/src'
import getQueryString from 'bjxy-common/helper/getQueryString';

var loginConfig = {
    product_type: 0, //产品id  1卡贷 2易贷 3普惠
    maskFindPass:false,
    showBottomWarning: true,
    ifCanShowPassword:false,
    ifClearInput: true,
    smsTplId:'10001150',
    smsTplVersion:'4',
    sourceType:'cardloan'
};

if(getQueryString('partnerName') === 'ZHONGXINAPI2'){
  loginConfig.maskFindPass = true
  loginConfig.noRegister = true
  loginConfig.product_type=15
  loginConfig.smsTplId='10005971'
  loginConfig.smsTplVersion='1'
  loginConfig.isShowFindPassword=false
}
if(getQueryString('partnerName') === 'ZHONGXINAPI'){
  loginConfig.maskFindPass = true
  loginConfig.noRegister = true
  loginConfig.product_type=17
  loginConfig.smsTplId='10005972'
  loginConfig.smsTplVersion='1'
  loginConfig.isShowFindPassword=false
}
if(getQueryString('partnerName') === 'ZHAOLIAN_JYD'){
  loginConfig.maskFindPass = true;
  loginConfig.noRegister = true;
  loginConfig.product_type=18;
  loginConfig.smsTplId='10006178';
  loginConfig.smsTplVersion='1'
  loginConfig.isShowFindPassword=false
  loginConfig.isShowLoginText=false
}

Object.assign(loginModule.login.state.config,loginConfig)


export default {
  modules: Object.assign({},loginModule),
  plugins:[].concat(loginplugins)
}
